import * as React from 'react'
import { useFormContext } from 'react-hook-form'

import { DateInput, DateInputProps } from '~/components/date-input/DateInput'
import {
  FieldElementWrapperProps,
  FieldWrapper
} from '~/components/field-wrapper/FieldWrapper'
import { useFieldError } from '~/components/form/useFieldError'
import { useFormCustomContext } from '~/components/form/useFormCustomContext'

type DateFieldProps = DateInputProps & FieldElementWrapperProps

export const DateField = ({
  className,
  hideLabel,
  label,
  name,
  validation,
  prompt,
  description,
  appearance,
  theme,
  ...remainingProps
}: DateFieldProps) => {
  const { register, trigger } = useFormContext()
  const context = useFormCustomContext()
  const { error } = useFieldError(name)
  const ref = validation ? register(validation) : register

  const formAppearance = context?.appearance || appearance
  const formTheme = context?.theme ?? theme

  return (
    <FieldWrapper
      className={className}
      description={description}
      error={error}
      fieldId={name}
      hideLabel={hideLabel}
      label={label}
      prompt={prompt}
      required={Boolean(validation?.required)}
      appearance={formAppearance}
    >
      <DateInput
        id={name}
        name={name}
        ref={ref}
        appearance={formAppearance}
        theme={formTheme}
        {...(error && { state: 'error' })}
        {...remainingProps}
        revalidate={trigger}
      />
    </FieldWrapper>
  )
}

DateField.displayName = 'DateField'
